export { Tags as TagsTable } from './Tags';
